function injectStyle (ssrContext) {
  require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-6a6d8e95\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SidebarElement.vue")
}
var Component = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SidebarElement.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6a6d8e95\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SidebarElement.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a6d8e95",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/parts/catalog/card/components/sidebar/components/SidebarElement.vue
// module id = 2fc1cc05423c160c5755
// module chunks = 0